import React from 'react';

import { EditProvider } from './src/editor/EditContext';
import { EditToolbar } from './src/editor/EditToolbar';

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => (
  <EditProvider>
    {element}
    <EditToolbar />
  </EditProvider>
);
